import {
  Card,
  Container,
  CardHeader,
  Divider,
  Grid,
  CardContent,
  createMuiTheme,
  Select,
  Typography,
  FormControl,
  TextField,
  CardActions,
  Button,
  CircularProgress,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  InputAdornment,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  Slide,
  LinearProgress,
  TableContainer,
  Checkbox,
  Backdrop,
  Slider,
  Input,
  Snackbar,
  TableSortLabel, IconButton
} from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import React, { useState } from 'react';
import Page from 'src/components/Page';
import { CustomTableCell } from 'src/components/CustomTableCell';
import axios from 'src/utils/axios';
import PrintIcon from '@material-ui/icons/Print';
import LockIcon from '@material-ui/icons/Lock';
import {
  getUser,
  sc,
  GetWarehouseAddress,
  getSepetAdet,
  setSepetAdet,
  CreateWareHouseAddress
} from 'src/utils/Common';
import DateFnsUtils from '@date-io/date-fns';
import BarcodeIade from 'src/components/BarcodeIade';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import CloseIcon from '@material-ui/icons/Close';
import GenericBulten from 'src/components/GenericBulletin';
import SendIcon from '@material-ui/icons/Send';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AddressSearch from 'src/components/Selects/AddressSearch';
import CropFreeIcon from '@material-ui/icons/CropFree';
import clsx from 'clsx';
import BarcodeVoice from 'src/assets/sound/Bip.mp3';
import ErrorVoice from 'src/assets/sound/Error.mp3';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import MuiAlert from '@material-ui/lab/Alert';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  tableSelected: {
    backgroundColor: '#FFFFDF',
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  cardScrollUst: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 600,
    minHeight: 600,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
}));
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};


function ArcelikReturnReport() {
  const classes = useStyles();
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [TeknisyenKodu, setTeknisyenKodu] = useState('');
  const [ZimmetAciklama, setZimmetAciklama] = useState('');
  const [TeknisyenData, setTeknisyenData] = useState([]);
  const [TeknisyenPlanData, setTeknisyenPlanData] = useState([]);
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [Loading, setLoading] = useState(false);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [ImageUrl, setImageUrl] = useState(null);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [previous, setPrevious] = React.useState({});
  const [selected, setSelected] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const SessionUser = getUser();
  const [Barcode, setBarcode] = useState('');
  const likeAudio = new Audio(BarcodeVoice);
  const ErrorAudio = new Audio(ErrorVoice);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [selectedRow, setselectedRow] = useState(-1);
  const [MaterialLeftData, setMaterialLeftData] = React.useState([]);
  const [MaterialRightData, setMaterialRightData] = React.useState([]);
  const [BarcodeData, setBarcodeData] = React.useState([]);
  const [SiparisParam, setSiparisParam] = React.useState('');
  const [Print, setPrint] = React.useState(false);
  const [Etiket, setEtiket] = React.useState('');



  React.useEffect(() => {
    axios
      .get(`/GetArcelikReturnReportMain/${SessionUser.ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          setMaterialLeftData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

  }, []);


  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      })
      .catch(error => {
        setLoadingMaterial(false);
      });
  };
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const isSelected = name => selected.indexOf(name) !== -1;

  const handleClick = (event, row, index) => {
    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let TeknisyenPlanDataOld = [...TeknisyenPlanData];
    setTeknisyenPlanData(TeknisyenPlanDataOld);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const playSound = audioFile => {
    audioFile.play();
  };

  const SetBarcodeAddItemKabul = (Barcode, Data) => {
    setLoading(true);
    axios
      .get('GetMaterialDescription/' + Barcode)
      .then(response => {
        setLoading(false);
        let Deger = {

          MALZEME: response.data,
          MALZEME_KODU: 0,
          MALZEME_STOK_NO: Barcode,
          RowSelected: 0,
          MIN_ADET: 1,
          MAX_ADET: 1
        };

        var VarMi = TeknisyenPlanData.filter(d => d.MALZEME_STOK_NO === Barcode);
        if (VarMi.length > 0) {
          var rowsParam = [...TeknisyenPlanData];
          var rowsParamIndex = TeknisyenPlanData.findIndex(d => d.MALZEME_STOK_NO === Barcode);
          rowsParam[rowsParamIndex].MAX_ADET = rowsParam[rowsParamIndex].MAX_ADET + 1;
          setTeknisyenPlanData(rowsParam);
        } else {
          let DegerOld = [Deger, ...TeknisyenPlanData];
          setTeknisyenPlanData(DegerOld);
        }

        setBarcode("");
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  const SetBarcodeAddItem = Barcode => {
    if (Barcode === '') {
      return;
    }
    playSound(ErrorAudio);
    var Varmi = TeknisyenPlanData.filter(
      d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
    );
    if (Varmi.length > 0) {
      var rowsParam = [
        ...TeknisyenPlanData.map(item => ({
          ...item
        }))
      ];
      var rowsParamIndex = TeknisyenPlanData.findIndex(
        d => d.MALZEME_STOK_NO === Barcode && d.FIS_NO === 'Fişsiz Malzeme'
      );
      rowsParam[rowsParamIndex].Count =
        parseInt(rowsParam[rowsParamIndex].Count) + 1;
      setTeknisyenPlanData(rowsParam);
      return;
    }
    axios
      .get('GetMaterialDescription/' + Barcode)
      .then(response => {
        if (response.data === '') {
          setUyariTip('error');
          setUyariAciklama(Barcode + ' stok numaralı malzeme sistemde tanımlı degil!...');
          setUyari(true);
          return;
        }

        SetBarcodeAddItemKabul(Barcode, response.data);

      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu lütfen tekrar deneyiniz!...');
        setUyari(true);
        return;
      });
  };

  const SepeteEkleDetay = event => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TEKNISYEN_KODU: SessionUser.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetMaterialBasket', data, config)
      .then(response => {
        if (response.data[0].ErrorCode === '0') {
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
          setUyariTip('success');
          setUyariAciklama('İşlem başarılı');
          setUyari(true);

        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..' + error.message);
        setUyari(true);
        setLoading(false);
      });
  };

  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(
      MALZEME_STOK_NO +
      ' numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?'
    );
    setopenSiparisAdet(true);
  };
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };


  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const headMalzemeZimmetCells = [
    { id: 'MALZEME_STOK_NO', numeric: true, disablePadding: true, label: 'MalzemeStokNo' },
    { id: 'ACIKLAMA', numeric: true, disablePadding: true, label: 'Malzeme' },
    { id: 'KDVSIZ_FIYAT', numeric: true, disablePadding: true, label: 'KdvsizFiyat' },
    { id: 'KDVLI_FIYAT', numeric: true, disablePadding: true, label: 'KdvliFiyat' },
    { id: 'MIKTAR', numeric: true, disablePadding: true, label: 'Miktar' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Resim' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Bülten' },
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'Sipariş' },

  ];

  const headMalzemeleftDataCells = [
    { id: 'SIPARIS_NO', numeric: true, disablePadding: true, label: 'SiparişNo' },
    { id: 'NEDEN', numeric: false, disablePadding: true, label: 'Neden' },
    { id: 'SIPNOT', numeric: false, disablePadding: true, label: 'SipNot' },
    { id: 'DURUM', numeric: false, disablePadding: true, label: 'Durum' },
    { id: 'TARIH', numeric: false, disablePadding: true, label: 'Tarih' },
  ];

  const MalzemeDetayiGoster = (row, index) => {
    setSiparisParam(row.SIPARIS_NO + " numaraları iade siparişi detayı!...");
    setLoading(true);
    setselectedRow(index);
    axios.get("GetArcelikReturnReportDetail/" + row.SIPARIS_NO)
      .then(response => {
        setMaterialRightData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });



  }

  const SetPrintParam = (event) => {
    var content = document.getElementById("dvPrint");
    let pri;
    const iframe = document.createElement('iframe')
    iframe.setAttribute('title', Etiket)
    iframe.setAttribute('id', Etiket)
    // iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;')
    document.body.appendChild(iframe);
    pri = iframe.contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();

  }

  const EtiketBas = () => {
    setBarcodeData(MaterialRightData);
    setEtiket("serdar");
    setPrint(true);
  }


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Snackbar open={uyari} autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={uyariKapat}>
        <Alert onClose={uyariKapat} severity={uyariTip}>
          {uyariAciklama || ''}
        </Alert>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader
            title="Arçelik İade Raporu"
            action={
              <Button
                variant="contained"
                color="secondary"
                onClick={() => EtiketBas()}
                className={classes.button}
                endIcon={<PrintIcon>Print</PrintIcon>}
              >
                Etiket Bas
              </Button>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={5}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader title="İade Belgeleri" />
                  <Backdrop className={classes.backdrop} open={Loading}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                  <Divider />
                  <CardContent>
                    <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                      <Table
                        stickyHeader
                        size={'small'}>
                        <EnhancedTableHead
                          classes={classes}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={handleRequestSort}
                          Header={headMalzemeleftDataCells}
                        />
                        <TableBody>
                          {stableSort(MaterialLeftData, getComparator(order, orderBy))
                            .map((row, index) => (
                              <TableRow key={index}
                                className={selectedRow === index ? classes.tableSelected : ""}
                              >
                                <TableCell padding='none' align="left" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                                  {row.SIPARIS_NO}
                                </TableCell>
                                <TableCell padding='none' align="left" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                                  {row.NEDEN}
                                </TableCell>
                                <TableCell padding='none' align="left" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                                  {row.SIPNOT}
                                </TableCell>
                                <TableCell padding='none' align="left" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                                  {row.DURUM}
                                </TableCell>
                                <TableCell padding='none' align="left" className={classes.tableCell}>
                                  {row.TARIH}
                                </TableCell>

                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                  <Divider />
                </Card>
              </Grid>
              <Grid item xs={12} sm={7}>
                <Card className={classes.cardUstBolum}>
                  <Divider />
                  <CardContent>
                    <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                      <Table
                        size="small"
                        stickyHeader>
                        <EnhancedTableHead
                          classes={classes}
                          order={order}
                          orderBy={orderBy}
                          onRequestSort={handleRequestSort}
                          Header={headMalzemeZimmetCells}
                        />
                        <TableBody>
                          {stableSort(MaterialRightData, getComparator(order, orderBy))
                            .map((row, index) => {
                              const isItemSelected = isSelected(index);
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isItemSelected}
                                >
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME_STOK_NO}
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    {row.ACIKLAMA}
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    title={row.KDVSIZ_FIYAT}
                                    className={classes.tableCell}
                                  >
                                    {row.KDVSIZ_FIYAT}
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    title={row.KDVSIZ_FIYAT}
                                    className={classes.tableCell}
                                  >
                                    {row.KDVLI_FIYAT}
                                  </TableCell>

                                  <TableCell
                                    align="left" padding='none'
                                    title={row.SIPNOT}
                                    className={classes.tableCell}
                                  >
                                    {row.MIKTAR}
                                  </TableCell>

                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    <ImageSearchIcon
                                      onClick={event =>
                                        GetMaterialImage(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    <FindInPageIcon
                                      onClick={event =>
                                        GetMaterialBulletin(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="left" padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.SIP_VERILEBILIR === 0 ?
                                      <LockIcon color="error" />
                                      :
                                      <AddShoppingCartIcon
                                        onClick={(event) => SepeteEkle(event, row.MALZEME_STOK_NO)}
                                        color="primary"
                                      />
                                    }

                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <GenericBulten param={bultenParam} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrl} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}
      >
        <DialogTitle>{SiparisAdetTitle}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 10,
                  min: 0,
                  max: 100,
                  type: 'number',
                  'aria-labelledby': 'input-slider'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Print}
        onClose={() => setPrint(false)}
        maxWidth={'md'}
        keepMounted
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Etiket Bas
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div id='dvPrint'>
            {BarcodeData?.map((item) => (
              <div align="center" style={{ paddingTop: '20px', paddingBottom: '23px' }}>
                <BarcodeIade Barcode={item.MALZEME_STOK_NO} Malzeme={item.ACIKLAMA} SiparisTarih={item.SIPARIS_TARIHI} Neden={item.NEDEN} SiparisNo={item.SIPARIS_NO} />
              </div>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => SetPrintParam(event)}
            className={classes.button}
            endIcon={<PrintIcon>Close</PrintIcon>}
          >
            Yazdır
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}

export default ArcelikReturnReport;
